import _startsWith from "lodash/startsWith";
import _toLower from "lodash/toLower";

export function createLink(linkLikeString: string) {
  if (_startsWith(_toLower(linkLikeString), "http")) return linkLikeString;

  return `http://${linkLikeString}`;
}
